import loadable from "loadable-components";
import LoadingIndicator from "../../components/LoadingIndicator";

export default loadable(() => import('./index'), {
    LoadingComponent: LoadingIndicator
});


// WEBPACK FOOTER //
// ./src/screens/Redirect/Loadable.js